<template>
  <div>
    <datepicker
      input-class="form-control custom-datepicker"
      calendar-class="calendar-datepicker"
      :placeholder="placeholder"
      :format="formatDate"
      :value="parseValue"
      :language="currentLang"
      :minimum-view="parseMin"
      :maximum-view="parseMax"
      :disabled-dates="parseStart"
      :clear-button="true"
      @input="onChange"
    />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  components: { Datepicker },
  props: {
    value: { type: [String, Object], default: undefined },
    change: {
      type: Function,
      default: undefined
    },
    min: { type: Number, default: undefined },
    max: { type: Number, default: undefined },
    placeholder: { type: String, default: 'Selecione um data' },
    start: { type: [String, Date], default: undefined },
    format: {
      type: [String],
      default: undefined
    }
  },
  methods: {
    formatDate(date) {
      if ((this.parseMin || this.parseMax) === 'day') {
        return moment(date).format('DD')
      }

      if ((this.parseMin || this.parseMax) === 'month') {
        return moment(date).format('MM')
      }

      if ((this.parseMin || this.parseMax) === 'year') {
        return moment(date).format('YYYY')
      }

      return moment(date).format('L')
    },
    onChange(value) {
      this.change && this.change(value)
      this.$emit('input', value)
      this.$emit('select', value)
    }
  },

  computed: {
    parseMin() {
      if (this.min === undefined) return
      const types = ['day', 'month', 'year']

      return types[this.min]
    },
    parseMax() {
      if (this.max === undefined) return
      const types = ['day', 'month', 'year']

      return types[this.max]
    },
    parseStart() {
      if (this.start === undefined) return

      const startDate = moment(this.start)

      if (!startDate.isValid()) return

      return {
        to: startDate.toDate()
      }
    },
    parseValue() {
      if (this.value === undefined) return

      const date = moment(this.value, [moment.ISO_8601, 'L'])

      if (!date.isValid()) return

      return date.toISOString()
    },
    currentLang() {
      return this.$i18n.locale === 'en' ? undefined : ptBR
    }
  }
}
</script>

<style>
.calendar-datepicker .cell {
  border-radius: 5px;
}

.calendar-datepicker .cell:hover {
  border-radius: 5px;
  border-color: #14ab65 !important;
}

.calendar-datepicker .cell.selected {
  border-radius: 5px;
  background-color: #14ab65 !important;
  color: white;
}

.vdp-datepicker__clear-button {
  display: block;
  float: right;
  top: -25px;
  right: 15px;
  position: relative;
}
</style>
